import React from "react"
import { ConnectDragSource, ConnectDropTarget, DragSource, DragSourceConnector, DragSourceMonitor, DropTarget, DropTargetConnector, DropTargetMonitor } from "react-dnd"
import DraggableItemData from "./DraggableItemData"
import Checkbox from "../Checkbox"
import { Col, Row } from "react-bootstrap"

export const DraggableTypeItem = "Item"

interface DraggableItemProps {
  item: DraggableItemData
  moveItem: (id: string, to: number) => void
  findItem: (id: string) => { index: number }
  excludeItem: (id: string, exclude: boolean) => void
}

interface DragDropItemProps extends DraggableItemProps {
  connectDragSource: ConnectDragSource
  isDragging: boolean
  connectDropTarget: ConnectDropTarget
}

const DraggableItemSource = {
  beginDrag(props: DraggableItemProps) {
    return {
      id: props.item.id,
      originalIndex: props.findItem(props.item.id).index
    }
  },
  endDrag(props: DraggableItemProps, monitor: DragSourceMonitor) {
    const item = monitor.getItem()
    if (!monitor.didDrop()) {
      props.moveItem(item.id, item.originalIndex)
    }
  }
}

const DraggableItemCollect = (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
})

const DroppableContainerTarget = {
  canDrop: () => false,
  hover(props: DraggableItemProps, monitor: DropTargetMonitor) {
    const { id: draggedId } = monitor.getItem()
    if (draggedId !== props.item.id) {
      const { index: overIndex } = props.findItem(props.item.id)
      props.moveItem(draggedId, overIndex)
    }
  }
}

const DroppableContainerCollect = (connect: DropTargetConnector) => ({ connectDropTarget: connect.dropTarget() })

class DraggableItem extends React.Component<DragDropItemProps> {

  render() {
    const { item, isDragging, connectDragSource, connectDropTarget } = this.props
    return connectDropTarget(connectDragSource(
      <div className={`draggable-item${isDragging ? " hovered" : ""}`}>
        <Row>
        <Col lg={9}>{item.name}</Col>
        {item.exclude !== undefined &&
          <Col lg={3}>
            <Checkbox id={`${item.id}_exclude`} name="Exclude" label="Exclude" checked={!!item.exclude} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.props.excludeItem(item.id, !!e.target.checked)}/>
          </Col>}
        </Row>
      </div>
    ))
  }
}

export default DropTarget(DraggableTypeItem, DroppableContainerTarget, DroppableContainerCollect)(DragSource(DraggableTypeItem, DraggableItemSource, DraggableItemCollect)(DraggableItem))
